import Vue from 'vue';
import App from './App';
import i18n from '../../common/js/i18n';
import '../../common/js/polyfills';
import '../../assets/iconfont/iconfont.css';
import showToast from '../../common/js/common';

Vue.prototype.$toast = showToast;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  i18n,
  components: { App },
});



// WEBPACK FOOTER //
// ./src/module/delAccount/delAccount.js